export const GAME_PHASE_IDS = [
  "selectingTotem",
  "selectingStart",
  "settling",
  "playing",
  "victory",
  "defeat",
] as const;

export type GamePhase = (typeof GAME_PHASE_IDS)[number];

export function isGamePhase(value: unknown): value is GamePhase {
  return (
    typeof value === "string" &&
    (GAME_PHASE_IDS as readonly string[]).includes(value)
  );
}
